[
  {
    "id": "vidal_prescription",
    "en": "The Vidal order",
    "fr": "L'ordonnance Vidal",
    "ordo_type": "ORD_VIDAL",
    "aliases": [
      "The Vidal Ordinance",
      "Vidal prescription",
      "Vidal ordonnance",
      "ordonnance vidal",
      "vidal"
    ]
  },
  {
    "id": "blank_prescription",
    "en": "Virgin Ordinance",
    "fr": "Ordonnance vierge",
    "ordo_type": "ORD_VIERGE",
    "aliases": [
      "Blank Prescription",
      "blank prescription",
      "blank",
      "ordonnance vierge"
    ]
  },
  {
    "id": "pre_established_prescription",
    "en": "Pre-established order",
    "fr": "Ordonnance préétablie",
    "ordo_type": "ORD_PRE_ETABLIE",
    "aliases": [
      "pre established order",
      "ordonnance pré établie",
      "ordonnance pre etablie",
      "ordonnance préétablie"
    ]
  },
  {
    "id": "imaging_prescription",
    "en": "Imaging order",
    "fr": "Ordonnance d'imagerie",
    "ordo_type": "ORD_IMAGERIE",
    "aliases": [
      "Imaging prescription",
      "imaging prescription",
      "imaging",
      "ordonnance d imagerie"
    ]
  },
  {
    "id": "angioplastie_test",
    "en": "Angioplasty_test",
    "fr": "Test angioplastie",
    "aliases": ["angioplastie test", "angioplastie"]
  },
  {
    "id": "coronary_ct_angiography",
    "en": "Coronary CT angiography",
    "fr": "Angioscanner coronaire",
    "aliases": ["coronary ct", "angioscanner coronaire", "angioscanner"]
  },
  {
    "id": "final_test",
    "en": "Final test",
    "fr": "Test final",
    "aliases": ["test finale", "test final"]
  }
]
